var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile"},[_c('div',{staticClass:"tile__title"},[_vm._t("header")],2),_c('div',{staticClass:"tile__description"},[_vm._t("content")],2),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }